/**
 * 
 * key
 * 
 */


const key = 'Y3JtV2lzZVBlbmRpbmdDbGllbnRDb3VudA=='

export default key 